var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkipimage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 482,
    height: 200,
    viewBox: "0 0 482 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4210_13330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.221 40.6076C333.366 40.6076 324.844 41.8303 316.73 44.1275C295.87 17.3027 263.303 0 226.697 0C172.38 0 126.956 38.0141 115.544 88.8477C114.062 88.5513 112.506 88.3661 110.913 88.3661C98.5009 88.3661 88.4602 98.4068 88.4602 110.819C88.4602 112.375 88.6084 113.857 88.9048 115.302C64.229 121.638 46 144.053 46 170.693C46 181.401 48.927 191.441 54.0771 200H408.875C425.548 183.105 435.848 159.874 435.848 134.235C435.848 82.512 393.944 40.6076 342.221 40.6076Z",
    fill: "#F8F8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.746 140.514C93.243 140.514 63.2616 165.65 54 200H203.551C194.23 165.712 164.308 140.514 128.746 140.514Z",
    fill: "#EEEFC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.734 140.514C297.231 140.514 267.25 165.65 257.988 200H407.539C398.218 165.712 368.296 140.514 332.734 140.514Z",
    fill: "#EEEFC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.546 115C184.786 115 142.04 150.917 128.741 199.998H342.351C329.112 150.98 286.307 115 235.546 115Z",
    fill: "#EEEFC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.214 163.595C393.214 163.543 393.214 163.438 393.214 163.386C393.161 162.81 392.586 162.392 392.01 162.444L384.42 163.386C383.844 163.438 383.426 164.014 383.478 164.59C383.53 165.166 384.106 165.584 384.682 165.532L392.272 164.59C392.795 164.485 393.214 164.066 393.214 163.595Z",
    fill: "#FDCC08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.12 162.337C391.12 162.337 393.476 160.767 393.737 161.343C394.051 161.918 397.611 170.712 397.244 170.921C395.883 171.602 391.905 164.85 391.748 164.064C391.644 163.332 390.754 162.547 391.12 162.337Z",
    fill: "#FD9CAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.598 98.4792C323.598 98.4792 319.672 94.6582 318.311 94.8153C316.951 94.9723 320.3 99.055 323.493 99.7878L323.598 98.4792Z",
    fill: "#FDCC08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.657 97.4336C322.186 98.1664 321.715 98.8992 321.296 99.632C333.23 106.803 339.616 109.211 353.329 106.436C355.423 106.018 355.528 105.18 354.847 103.558C355.109 103.348 355.161 103.348 354.847 103.558C354.219 101.935 353.643 101.883 351.602 102.301C338.359 105.233 334.905 102.772 322.657 97.4336Z",
    fill: "#EC577F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.92 195.784C350.973 195.784 351.078 195.784 351.13 195.784C351.706 195.679 352.072 195.104 351.967 194.528L350.449 187.043C350.345 186.467 349.769 186.101 349.193 186.205C348.617 186.31 348.251 186.886 348.356 187.462L349.874 194.946C349.978 195.47 350.397 195.784 350.92 195.784Z",
    fill: "#FDCC08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.565 191.439C349.716 191.387 350.815 191.282 351.967 191.125C348.617 173.119 346.052 148.885 355.055 132.031C352.333 130.67 349.559 129.361 346.785 128.053C340.19 142.761 345.843 175.946 348.565 191.439Z",
    fill: "#202121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.131 165.74C389.026 164.589 388.816 163.49 388.607 162.338C361.913 165.793 351.654 157.732 357.464 129.467C354.48 128.63 351.444 127.897 348.408 127.164C345.791 158.936 358.929 169.352 389.131 165.74Z",
    fill: "#434547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.036 89.2678C350.082 88.6397 351.705 88.6921 352.542 89.5295C353.38 90.367 353.066 91.8849 352.176 92.7224C351.286 93.6122 348.774 93.6122 347.936 92.7748C347.099 91.885 347.727 90.053 349.036 89.2678Z",
    fill: "#202121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.802 94.6077C364.268 92.671 367.409 91.5195 369.712 92.4617C372.067 93.4038 372.747 96.3873 371.858 98.638C370.968 100.889 367.094 103.087 363.483 101.988C361.127 101.203 360.97 97.0678 362.802 94.6077Z",
    fill: "#202121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.971 93.2981C362.018 91.8325 364.321 90.9426 365.996 91.6231C367.671 92.3035 368.142 94.5019 367.461 96.1769C366.781 97.8518 363.326 99.3697 361.651 98.6893C359.924 98.0088 359.61 95.1824 360.971 93.2981Z",
    fill: "#202121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.381 89.7383C353.381 89.7383 356.679 92.2507 358.773 92.0414C360.866 91.832 362.018 91.4132 364.059 93.2976C366.101 95.1819 367.88 92.4077 369.398 94.9202C370.864 97.4326 366.781 103.871 362.28 101.463C358.563 99.4739 359.663 98.5318 357.045 98.7935C355.999 98.8982 354.167 98.7411 352.649 97.3279C351.078 95.9147 353.381 89.7383 353.381 89.7383Z",
    fill: "#202121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.104 94.5016C356.104 97.7468 353.853 100.312 351.917 100.312C349.928 100.312 348.985 97.6945 348.985 94.5016C348.985 91.2564 350.556 89.6338 352.545 89.6338C354.534 89.6338 356.104 91.2564 356.104 94.5016Z",
    fill: "#FDCC08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.568 95.6011C357.568 96.3339 356.835 97.3284 356.26 97.3284C355.684 97.3284 355.579 96.7003 355.579 95.9675C355.579 95.2348 355.998 94.502 356.574 94.502C357.149 94.502 357.568 94.8684 357.568 95.6011Z",
    fill: "#FDCC08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.575 92.4612C356.575 92.4612 355.894 90.4198 354.272 89.6347C352.649 88.9019 349.561 89.0066 348.88 91.8854C348.88 91.8854 348.566 93.9791 351.131 94.0838C353.696 94.1885 353.12 92.9323 354.429 94.0838C355.737 95.2353 356.784 94.2408 357.046 94.5025L356.575 92.4612Z",
    fill: "#202121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.798 135.433C346.787 135.485 349.404 135.066 351.812 133.81C353.696 132.868 355.842 132.554 357.674 132.449C358.145 126.011 359.192 109 358.197 105.912C356.941 102.038 354.691 100.363 354.691 100.363C354.691 100.363 353.277 101.619 352.178 101.515C351.131 101.41 349.875 105.074 348.409 107.429C346.944 109.785 345.74 110.518 346.996 114.129C347.467 115.647 344.536 133.182 344.798 135.433Z",
    fill: "#FD9CAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.946 96.2301L352.596 95.916C352.543 96.3871 352.177 100.784 352.386 102.406C352.491 102.93 353.329 103.139 354.271 102.93C355.108 102.72 355.684 102.249 355.684 101.778C355.579 100.784 355.789 97.8527 355.946 96.2301Z",
    fill: "#FDCC08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.229 194.37C352.229 194.37 352.91 197.092 352.229 197.197C351.549 197.249 342.075 197.563 342.023 197.144C341.813 195.627 349.612 194.266 350.345 194.423C351.13 194.527 352.177 194.004 352.229 194.37Z",
    fill: "#FD9CAE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 28,
    width: 127.841,
    height: 150,
    fill: "#BF89F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.102 36.5215H171.521V169.476H282.102V36.5215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 48.4072H180.956V50.7365H208.846V48.4072Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 48.4072H212.405V50.7365H240.296V48.4072Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 48.4072H243.908V50.7365H271.799V48.4072Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 53.2012H180.956V55.5305H208.846V53.2012Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 53.2012H212.405V55.5305H240.296V53.2012Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 53.2012H243.908V55.5305H271.799V53.2012Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 57.9102H180.956V60.2395H208.846V57.9102Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 57.9102H212.405V60.2395H240.296V57.9102Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 57.9102H243.908V60.2395H271.799V57.9102Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 62.6348H180.956V64.9641H208.846V62.6348Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 62.6348H212.405V64.9641H240.296V62.6348Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 62.6348H243.908V64.9641H271.799V62.6348Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 67.3584H180.956V69.6877H208.846V67.3584Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 67.3584H212.405V69.6877H240.296V67.3584Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 67.3584H243.908V69.6877H271.799V67.3584Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 72.1406H180.956V74.4699H208.846V72.1406Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 72.1406H212.405V74.4699H240.296V72.1406Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 72.1406H243.908V74.4699H271.799V72.1406Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 76.8496H180.956V79.1789H208.846V76.8496Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 76.8496H212.405V79.1789H240.296V76.8496Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 76.8496H243.908V79.1789H271.799V76.8496Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 81.5752H180.956V83.9045H208.846V81.5752Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 81.5752H212.405V83.9045H240.296V81.5752Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 81.5752H243.908V83.9045H271.799V81.5752Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 86.3018H180.956V88.6311H208.846V86.3018Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 86.3018H212.405V88.6311H240.296V86.3018Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 86.3018H243.908V88.6311H271.799V86.3018Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 91.0781H180.956V93.4074H208.846V91.0781Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 91.0781H212.405V93.4074H240.296V91.0781Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 91.0781H243.908V93.4074H271.799V91.0781Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 95.791H180.956V98.1203H208.846V95.791Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 95.791H212.405V98.1203H240.296V95.791Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 95.791H243.908V98.1203H271.799V95.791Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 100.516H180.956V102.845H208.846V100.516Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 100.516H212.405V102.845H240.296V100.516Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 100.516H243.908V102.845H271.799V100.516Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 105.239H180.956V107.569H208.846V105.239Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 105.239H212.405V107.569H240.296V105.239Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 105.239H243.908V107.569H271.799V105.239Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 110.019H180.956V112.348H208.846V110.019Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 110.019H212.405V112.348H240.296V110.019Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 110.019H243.908V112.348H271.799V110.019Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 114.744H180.956V117.073H208.846V114.744Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 114.744H212.405V117.073H240.296V114.744Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 114.744H243.908V117.073H271.799V114.744Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 119.454H180.956V121.783H208.846V119.454Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 119.454H212.405V121.783H240.296V119.454Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 119.454H243.908V121.783H271.799V119.454Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 124.179H180.956V126.508H208.846V124.179Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 124.179H212.405V126.508H240.296V124.179Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 124.179H243.908V126.508H271.799V124.179Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 128.955H180.956V131.284H208.846V128.955Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 128.955H212.405V131.284H240.296V128.955Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 128.955H243.908V131.284H271.799V128.955Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 133.684H180.956V136.013H208.846V133.684Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 133.684H212.405V136.013H240.296V133.684Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 133.684H243.908V136.013H271.799V133.684Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 138.393H180.956V140.722H208.846V138.393Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 138.393H212.405V140.722H240.296V138.393Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 138.393H243.908V140.722H271.799V138.393Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 143.119H180.956V145.448H208.846V143.119Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 143.119H212.405V145.448H240.296V143.119Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 143.119H243.908V145.448H271.799V143.119Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 147.896H180.956V150.225H208.846V147.896Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.296 147.896H212.405V150.225H240.296V147.896Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.799 147.896H243.908V150.225H271.799V147.896Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.293 48.4082H180.957V64.9586H240.293V48.4082Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.502 119.819H243.611V140.722H271.502V119.819Z",
    fill: "#DEC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.985 83.2833L295.28 78.4326L352.195 128.833L347.9 133.683L290.985 83.2833Z",
    fill: "#292B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.718 99.8226L313.591 92.0615L354.919 128.659L348.046 136.42L306.718 99.8226Z",
    fill: "#C6D64E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 28.3484C248.772 11.5254 274.457 9.9573 291.358 24.8542C308.181 39.7884 309.749 65.4734 294.852 82.3743C279.918 99.1973 254.233 100.765 237.332 85.8685C220.472 70.8564 218.904 45.1714 233.838 28.3484ZM292.036 79.8915C305.591 64.5904 304.139 41.1487 288.838 27.5931C273.537 14.0375 250.095 15.4896 236.54 30.7906C222.984 46.0916 224.436 69.5334 239.737 83.089C255.038 96.6445 278.48 95.1925 292.036 79.8915Z",
    fill: "#292B3B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M280.29 88.77C261.828 97.6081 239.696 89.806 230.858 71.3435C222.02 52.8809 229.822 30.7493 248.284 21.9111C266.747 13.0729 288.879 20.8751 297.717 39.3376C306.555 57.8002 298.753 79.9318 280.29 88.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.496 116.172C332.496 116.172 328.047 112.508 326.634 112.822C325.221 113.136 329.041 117.062 332.496 117.585V116.172Z",
    fill: "#FDCC08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.025 115.595C331.658 116.381 331.292 117.218 330.873 117.951C344.744 124.389 354.95 125.645 358.405 108.634C358.928 106.017 357.829 106.488 356.73 105.65C354.846 105.964 354.375 105.598 354.061 108.006C351.81 123.97 344.011 118.998 332.025 115.595Z",
    fill: "#EC577F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4210_13330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 482,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipimage);
export default __webpack_public_path__ + "static/media/skipimage.d0ad278d89f7132821790030a3a67f31.svg";
export { ForwardRef as ReactComponent };